import React, { useState, useEffect, useRef, useCallback } from 'react';
import { supabase } from '../supabaseClient';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import buttonImage from '../buttonimage.webp';
import adminLogo from '../assets/animations/animation2.webp';

const STRIPE_CHECKOUT_URL = 'https://zxvjqkrfvproyblrjcst.supabase.co/functions/v1/create-subscription';

const MyAccount = ({ goBack, setCurrentPage }) => {
    const [userData, setUserData] = useState(null);
    const [nickname, setNickname] = useState('');
    const [nicknameChanged, setNicknameChanged] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
        // eslint-disable-next-line no-unused-vars
        const [loading, setLoading] = useState(true);
    const [selectedMembership, setSelectedMembership] = useState(null);
    const [hoveredMembership, setHoveredMembership] = useState(null);
    const [couponCode, setCouponCode] = useState('');
    const [userId, setUserId] = useState(null);
    const [paymentConfirmed, setPaymentConfirmed] = useState(false);
    const [subscriptionId, setSubscriptionId] = useState(null);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [navigateToAdmin, setNavigateToAdmin] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('paypal');

    const membershipOptions = [
        { type: 'Free', description: 'Thank you for signing up. You are invited to a Monthly or Yearly Subscription to gain access to the App.', id: 'None' },
        { type: 'Monthly', description: 'Billed Automatically Each Month Unless Cancelled, No Refunds, Full Access to Unlimited New Sessions, Resume Last Session, Oracle, Quick Reference (self reflection tools), Journal, Meditation, To-Do, and Community Chat Room and JulieCam live sessions. Change Membership Type at any time. No Refunds', id: 'Monthly' },
        { type: 'Yearly', description: 'Billed Automatically Each Year Unless Cancelled, No Refunds, Full Access to Unlimited New Sessions, Resume Last Session, Oracle, Quick Reference (self reflection tools), Journal, Meditation, To-Do, and Community Chat Room and JulieCam live sessions. Change Membership Type at any time. No Refunds', id: 'Yearly' },
        { type: 'Gift', description: 'Full Access to Unlimited New Sessions, Resume Last Session, Oracle, Quick Reference (self reflection tools), Journal, Meditation, To-Do, and Community Chat Room and JulieCam live sessions. Change Membership Type at any time. No Refunds', id: 'Gift' },
    ];

    const getWelcomeMessageForMembership = (profile, membershipType) => {
        const welcomeMessages = {
            'Free Subscription': [
                `Welcome, ${profile.nickname || profile.first_name || 'User'}!`,
                `To gain access to the App you will need to choose a subscription. Your subscription will give you access to the to-do list, and the Journal, to keep track of what you are working on or what you will be working on next. You will have full access to the Oracle, Meditation offerings, New Session and the Companion function. Your membership includes access to Quick Reference where many of the concepts and reflection tools are easily recalled. Monthly and Yearly Subscription Memberships also offer use of the Community Chat, and access to JulieCam Live sessions. The App is being devloped continually and may be updated from time to time to allow the new features and enhancements. No Refunds`,
                `You may change your membership type at any time here on the My Account page.`
            ],
            'Monthly Subscription': [
                `Welcome, ${profile.nickname || profile.first_name || 'User'}!`,
                `Your Monthly Membership is now Active. You have Full use of the App with this membership. We hope that you will take advantage of unlimited New Sessions. You also have access to the To-do list to keep track of what you are working on, or what you will be working on next. You have full access to the Oracle, the Meditation offerings, the Chat room, JulieCam live sessions, the Journal and Quick Reference where all the Reflection formulas and Reflection tools are easily recalled. The App is being devloped continually and will need to be updated from time to time to allow the new features and enhancements.`,
                `You may change your membership type at any time here on the My Account page. No Refunds.`
            ],
            'Yearly Subscription': [
                `Welcome, ${profile.nickname || profile.first_name || 'User'}!`,
                `Your Yearly Membership is now Active. You have Full use of the App with this membership. We hope that you will take advantage of unlimited New Sessions. You also have access to the To-do list to keep track of what you are working on, or what you will be working on next. You have full access to the Oracle, the Meditation offerings, the Chat room, JulieCam live sessions, the Journal and Quick Reference where all the Reflection formulas and Reflection tools are easily recalled. The App is being devloped continually and will need to be updated from time to time to allow the new features and enhancements.`,
                `You may change your membership type at any time here on the My Account page. No Refunds.`
            ],
            'Gift Subscription': [
                `Welcome, ${profile.nickname || profile.first_name || 'User'}!`,
                `Your Gift Membership is now Active. You have Full use of the App with this membership. We hope that you will take advantage of unlimited New Sessions. You also have access to the To-do list to keep track of what you are working on, or what you will be working on next. You have full access to the Oracle, the Meditation offerings, the Chat room, JulieCam live sessions, the Journal and Quick Reference where all the Reflection formulas and Reflection tools are easily recalled. The App is being devloped continually and will need to be updated from time to time to allow the new features and enhancements.`,
                `You may change your membership type at any time here on the My Account page. If you have another coupon code to use you can enter it as if you are changing your membership to gift membership, but you cannot add two coupons in the same day. Wait a day before adding a second coupon. `
            ]
        };
        const membershipMapping = {
            'None': 'Free Subscription',
            'Monthly': 'Monthly Subscription',
            'Yearly': 'Yearly Subscription',
            'Gift': 'Gift Subscription'
        };
        const mappedMembershipType = membershipMapping[profile.membership] || membershipType || 'Free Subscription';
        let message = welcomeMessages[mappedMembershipType] || welcomeMessages['Free Subscription'];

        if (profile.next_membership && new Date(profile.next_membership_start) > new Date()) {
            const nextType = membershipMapping[profile.next_membership] || profile.next_membership;
            message.push(`Pending: ${nextType} starting ${new Date(profile.next_membership_start).toLocaleDateString()}.`);
        }

        return message;
    };

    const handleMembershipSelect = (type) => {
        setSelectedMembership(type === selectedMembership ? null : type);
        setPaymentMethod('paypal');
    };

    const callDeleteAccountEdgeFunction = async (userId, subscriptionId) => {
        try {
            const { data: { session } } = await supabase.auth.getSession();
            const token = session?.access_token;
            if (!token) throw new Error('No active session. Please log in.');

            const res = await fetch(
                'https://zxvjqkrfvproyblrjcst.supabase.co/functions/v1/cancel-subscription',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        user_id: userId,
                        subscription_id: subscriptionId || null,
                    }),
                }
            );
            const data = await res.json();
            if (!res.ok) throw new Error(data.error || 'Failed to delete account');
            return { success: true, data };
        } catch (err) {
            throw err;
        }
    };

    const handleChangeMembership = async (type, code = null) => {
        try {
            const { data: profile } = await supabase.from('user_profiles').select('id, membership_type, membership_end_date, next_membership, next_membership_start, subscription_id, payment_processor, current_period_end').eq('id', userData.id).single();
            if (profile.next_membership) {
                alert('One pending membership at a time. Try again after current membership expires.');
                return;
            }

            const now = new Date();
            const isActive = profile.membership_end_date && new Date(profile.membership_end_date) > now;
            let startDate = isActive ? new Date(new Date(profile.membership_end_date).getTime() + 24 * 60 * 60 * 1000).toISOString() : now.toISOString();

            const membership = membershipOptions.find(option => option.type === type).id;

            if (type === 'Free') {
                // Cancel PayPal subscription if active and payment_processor is paypal
                if (isActive && profile.payment_processor === 'paypal' && profile.subscription_id) {
                    const { data: { session } } = await supabase.auth.getSession();
                    const res = await fetch('/functions/v1/cancel-paypal-sub', {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${session.access_token}`,
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            user_id: userData.id,
                            subscription_id: profile.subscription_id,
                            next_start_date: profile.membership_end_date || profile.current_period_end,
                        }),
                    });

                    if (!res.ok) {
                        const err = await res.json();
                        alert(err.error || 'Failed to cancel PayPal');
                        return;
                    }

                    const data = await res.json();
                    alert(data.message);

                    // Remove PayPal subscription_id from profile
                    await supabase.from('user_profiles').update({
                        subscription_id: null,
                    }).eq('id', userData.id);
                }
                // ...existing Stripe cancellation logic if any...

                // Queue Free membership
                await supabase.from('user_profiles').update({
                    next_membership: 'Free Subscription',
                    next_membership_start: profile.membership_end_date || profile.current_period_end,
                    membership: membership,
                }).eq('id', userData.id);

                alert(`Your change to Membership will take effect when your current paid period ends on ${new Date(profile.membership_end_date).toLocaleDateString()}. Your subscription has been canceled to avoid further charges.`);
            } else if (type === 'Gift' && code) {
                // Step 1: Check for pending subscription and handle notification
                if (profile.next_membership && profile.next_membership_start && new Date(profile.next_membership_start) > new Date()) {
                    alert('You already have a pending subscription. Try again after your next subscription starts.');
                    return;
                }
                // Step 2: Handle Free, Gift, and Paid memberships for gift coupon
                let activateGiftImmediately = false;
                let queueGiftAfter = null;
                let queueGift = false;

                if (
                    !profile.membership_type ||
                    profile.membership_type === 'Free Subscription' ||
                    !profile.membership_end_date ||
                    new Date(profile.membership_end_date) <= new Date()
                ) {
                    // Free or expired: activate gift immediately
                    activateGiftImmediately = true;
                } else if (profile.membership_type === 'Gift Subscription') {
                    // Queue new gift after current gift ends
                    queueGift = true;
                    queueGiftAfter = profile.membership_end_date;
                } else if (
                    profile.membership_type === 'Monthly Subscription' ||
                    profile.membership_type === 'Yearly Subscription'
                ) {
                    // Paid: cancel paid subscription, then queue gift
                    if (profile.payment_processor === 'paypal' && profile.subscription_id) {
                        try {
                            const { data: { session } } = await supabase.auth.getSession();
                            const token = session?.access_token;
                            await fetch('/functions/v1/cancel-paypal-sub', {
                                method: 'POST',
                                headers: {
                                    'Authorization': `Bearer ${token}`,
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    user_id: userData.id,
                                    subscription_id: profile.subscription_id,
                                    next_start_date: profile.membership_end_date,
                                }),
                            });
                        } catch (err) {
                            alert('Failed to cancel PayPal subscription. Please try again or contact support.');
                            return;
                        }
                    } else if (profile.payment_processor === 'stripe' && profile.subscription_id) {
                        try {
                            const { data: { session } } = await supabase.auth.getSession();
                            const token = session?.access_token;
                            await fetch('/functions/v1/cancel-stripe', {
                                method: 'POST',
                                headers: {
                                    'Authorization': `Bearer ${token}`,
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    user_id: userData.id,
                                    subscription_id: profile.subscription_id,
                                    next_start_date: profile.membership_end_date,
                                }),
                            });
                        } catch (err) {
                            alert('Failed to cancel Stripe subscription. Please try again or contact support.');
                            return;
                        }
                    }
                    queueGift = true;
                    queueGiftAfter = profile.membership_end_date;
                }

                const response = await supabase
                    .schema('public')
                    .from('coupons')
                    .select('duration, redeemed_at, used, user_id')
                    .eq('code', code)
                    .eq('used', false)
                    .maybeSingle()
                    .setHeader('Accept', 'application/json');
                console.log('Supabase coupon query response:', response);

                const { data: couponData, error: couponError } = response;
                if (couponError || !couponData) {
                    alert(`Invalid coupon: ${couponError?.message || 'Coupon not found or already used.'}`);
                    return;
                }

                let durationInDays = parseInt(couponData.duration, 10) || 0;
                let redeemedAt = couponData.redeemed_at ? new Date(couponData.redeemed_at) : new Date();
                if (isNaN(redeemedAt.getTime())) redeemedAt = new Date();

                // removed unused variable newEndDate
                let updates = {
                    membership: membership,
                };

                if (activateGiftImmediately) {
                    // Activate gift immediately
                    const now = new Date();
                    const startDate = now.toISOString();
                    const endDate = new Date(now.getTime() + durationInDays * 24 * 60 * 60 * 1000).toISOString();
                    // removed unused assignment to newEndDate
                    updates = {
                        ...updates,
                        membership_type: 'Gift Subscription',
                        membership_end_date: endDate,
                        subscription_start_date: startDate,
                        current_period_end: endDate,
                        next_membership: null,
                        next_membership_start: null,
                    };
                } else if (queueGift) {
                    // Queue gift after current membership (gift or paid)
                    updates = {
                        ...updates,
                        next_membership: 'Gift Subscription',
                        next_membership_start: queueGiftAfter,
                        // Do not update membership_type or membership_end_date here
                    };
                }

                const { error: profileUpdateError } = await supabase
                    .from('user_profiles')
                    .update(updates)
                    .eq('id', userData.id);

                if (profileUpdateError) {
                    console.error('Error updating profile:', profileUpdateError.message);
                    alert('Failed to activate Gift Membership.');
                    return;
                }

                const couponUpdateResponse = await supabase
                    .schema('public')
                    .from('coupons')
                    .update({ used: true, redeemed_at: new Date().toISOString(), user_id: userData.id })
                    .eq('code', code)
                    .setHeader('Accept', 'application/json');
                const { error: couponUsedError } = couponUpdateResponse;
                if (couponUsedError) {
                    console.error('Error marking coupon as used:', couponUsedError.message);
                    alert('Failed to activate Gift Membership.');
                    return;
                }

                if (activateGiftImmediately) {
                    alert('Gift coupon accepted! Your Gift Membership is now active.');
                } else if (queueGift) {
                    alert('Gift coupon accepted! Your Gift Membership will begin when your current membership ends.');
                }
            } else if (type === 'Monthly' || type === 'Yearly') {
                const { error } = await supabase.from('user_profiles').update({
                    next_membership: `${type} Subscription`,
                    next_membership_start: startDate,
                    membership: membership,
                }).eq('id', userData.id);
                if (error) throw error;
                alert(isActive
                    ? `${type} Membership will be scheduled to start on ${new Date(startDate).toLocaleDateString()} after payment.`
                    : `${type} Membership will be activated after payment.`);
            }

            await fetchUserData();
        } catch (err) {
            console.error('handleChangeMembership error:', err);
            alert('Failed to process membership change. Please try again.');
        }
    };

    const handleDeleteAccount = async () => {
        setShowDeleteConfirm(true);
    };

    const confirmDeleteAccount = async (confirm) => {
        setShowDeleteConfirm(false);
        if (!confirm) return;

        if (!window.confirm('Any Active Subscriptions will be Cancelled. You may reactivate your account by starting a new subscription at any time. Email support to request deletion from the records completely. startellina@gmail.com')) {
            return;
        }
        try {
                let result;
                try {
                    result = await callDeleteAccountEdgeFunction(userData.id);
                } catch (err) {
                    // If parsing fails, treat as no active subscription
                    alert('Any paid subscriptions have been cancelled. To delete account from the record completely Please email support startellina@gmail.com');
                    return;
                }
                if (result && result.success) {
                    alert('Any paid subscriptions have been cancelled. To delete account from the record completely Please email support startellina@gmail.com');
                    await fetchUserData();
                    setCurrentPage('login');
                } else {
                    alert('Any paid subscriptions have been cancelled. To delete account from the record completely Please email support startellina@gmail.com');
                }
        } catch (err) {
            console.error('Error deleting account:', err.message);
            alert('Any paid subscriptions have been cancelled. To delete account from the record completely Please email support startellina@gmail.com');
        }
    };





    const handleStripeCheckout = async () => {
        try {
            const createCheckoutSession = async (priceId) => {
                const { data: { session } } = await supabase.auth.getSession();
                const token = session?.access_token;
                if (!token) throw new Error('No active session. Please log in.');

                const res = await fetch(STRIPE_CHECKOUT_URL, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        user_id: userId,
                        price_id: priceId,
                        membership_type: `${selectedMembership} Subscription`,
                    }),
                });

                let data;
                try {
                    data = await res.json();
                    console.log('Parsed JSON:', data);
                } catch (e) {
                    console.error('Failed to parse JSON.', e);
                    throw new Error('Invalid response from server');
                }

                if (!res.ok) {
                    // If the backend returns a specific error code/message, throw it
                    const msg = data.error || 'Failed to process payment. Please try again.';
                    throw new Error(msg);
                }

                if (!data.url) {
                    throw new Error('No checkout URL returned');
                }

                return { url: data.url };
            };

            const priceId = selectedMembership === 'Monthly'
                ? 'price_1SV2SICKkXYITxCEqNwbVMaP'
                : 'price_1SV2SFCKkXYITxCEh4k7yktI';

            try {
                const session = await createCheckoutSession(priceId);
                window.location = session.url;
            } catch (err) {
                const errMsg = (typeof err === "string" ? err : (err.message || err.error || ""));
                console.error("Checkout error (inner):", err, errMsg);
                if (
                    errMsg.includes("TOO_EARLY") ||
                    errMsg.includes("Please wait until your current subscription is closer to expiry")
                ) {
                    alert("Please wait until your current subscription is closer to expiry before adding another subscription.");
                } else if (
                    errMsg.includes("pending membership") ||
                    errMsg.includes("already have a pending membership")
                ) {
                    alert(errMsg);
                } else if (errMsg) {
                    alert(errMsg);
                } else {
                    alert("Unable to start checkout. Please try again or contact support.");
                }
            }
        } catch (err) {
            const errMsg = (typeof err === "string" ? err : (err.message || err.error || ""));
            console.error('Stripe checkout error (outer):', err, errMsg);
            if (
                errMsg.includes("TOO_EARLY") ||
                errMsg.includes("Please wait until your current subscription is closer to expiry")
            ) {
                alert("Please wait until your current subscription is closer to expiry before adding another subscription.");
            } else {
                alert('Failed to process payment. Please try again.');
            }
        }
    };

    const useEffectRenderCount = useRef(0);

    const fetchUserData = useCallback(async () => {
        try {
            setLoading(true);
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                console.error('Error fetching user:', userError);
                alert('User not logged in!');
                setUserData(null);
                return;
            }

            const { data: profile, error: profileError } = await supabase
                .from('user_profiles')
                .select('id, email, nickname, first_name, membership, membership_type, membership_end_date, subscription_id, nickname_changed, created_at, next_membership, next_membership_start, role, id')
                .eq('id', user.id)
                .maybeSingle();

            if (profileError) {
                console.error('Profile fetch error:', profileError.message);
                alert('Failed to load user profile.');
                setUserData(null);
                return;
            }

            if (!profile) {
                console.error('No profile found for user.');
                alert('No profile found.');
                setUserData(null);
                return;
            }

            const welcomeMessage = getWelcomeMessageForMembership(profile, profile.membership_type);

            setUserData(prev => {
                const newData = { ...profile, welcomeMessage };
                if (JSON.stringify(prev) === JSON.stringify(newData)) return prev;
                return newData;
            });
            setNickname(profile.nickname || profile.first_name || '');
            setNicknameChanged(profile.nickname_changed || false);

            if (profile.subscription_id) {
                setPaymentConfirmed(true);
                setSubscriptionId(profile.subscription_id);
            }
        } catch (err) {
            console.error('Unexpected error:', err);
            alert('An unexpected error occurred.');
            setUserData(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        console.log('useEffect triggered, current page:', window.location.pathname);
        useEffectRenderCount.current++;
        console.log('useEffect render count:', useEffectRenderCount.current);
        if (useEffectRenderCount.current > 5) {
            console.log('Infinite loop detected, stopping further renders');
            return;
        }
        console.log('MyAccount useEffect started');

        const initialize = async () => {
            await fetchUserData();

            const { data: { user } } = await supabase.auth.getUser();
            if (user) {
                setUserId(user.id);
            }

            const urlParams = new URLSearchParams(window.location.search);
            const tx = urlParams.get('tx');
            if (tx) {
                setPaymentConfirmed(true);
                setSubscriptionId(tx);
                await fetchUserData();
                window.history.replaceState({}, document.title, window.location.pathname);
            }
        };

        initialize();
    }, [fetchUserData]);

    useEffect(() => {
        window.setCurrentPage = setCurrentPage;
        return () => {
            if (window.setCurrentPage === setCurrentPage) {
                delete window.setCurrentPage;
            }
        };
    }, [setCurrentPage]);

    const handleNicknameChange = async () => {
        if (!nickname || nicknameChanged) {
            alert('Nickname change is not allowed or already used.');
            return;
        }

        try {
            const { error } = await supabase
                .from('user_profiles')
                .update({ nickname, nickname_changed: true })
                .eq('id', userData.id);

            if (error) {
                console.error('Error updating nickname:', error.message);
                alert(`Failed to update nickname: ${error.message}`);
                return;
            }

            alert('Nickname updated successfully!');
            setNicknameChanged(true);
            await fetchUserData();
        } catch (err) {
            console.error('Unexpected error:', err);
            alert('An unexpected error occurred.');
        }
    };

    const handlePasswordChange = async () => {
        try {
            const { error: signInError } = await supabase.auth.signInWithPassword({
                email: userData.email,
                password: currentPassword,
            });

            if (signInError) {
                alert('Invalid current password.');
                return;
            }

            if (newPassword !== confirmPassword) {
                alert("Passwords don't match.");
                return;
            }

            const { error: updateError } = await supabase.auth.updateUser({ password: newPassword });

            if (updateError) {
                console.error('Error updating password:', updateError.message);
                alert('Failed to update password.');
                return;
            }

            alert('Password updated successfully!');
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
            await fetchUserData();
        } catch (err) {
            console.error('Unexpected error:', err);
            alert('An unexpected error occurred.');
        }
    };

    const handleForgotPassword = async () => {
        try {
            const { error } = await supabase.auth.resetPasswordForEmail(userData.email, {
                redirectTo: 'https://www.companionjulie.com/reset-password',
            });

            if (error) {
                console.error('Error sending reset email:', error.message);
                alert('Failed to send reset email.');
                return;
            }

            alert('Reset email sent!');
        } catch (err) {
            console.error('Unexpected error:', err);
            alert('An unexpected error occurred.');
        }
    };

    const handleLogout = async () => {
        try {
            const { error } = await supabase.auth.signOut();
            if (error) {
                console.error('Error logging out:', error.message);
                alert('Failed to log out.');
                return;
            }
            setCurrentPage('login');
        } catch (err) {
            console.error('Unexpected error during logout:', err);
            alert('An unexpected error occurred.');
        }
    };

    const handleAdminClick = () => {
        if (userData && userData.role === 'admin') {
            setNavigateToAdmin(true);
        } else {
            console.warn('Admin access denied for user:', userData?.email);
        }
    };

    useEffect(() => {
        if (navigateToAdmin && userData) {
            setCurrentPage('adminPanel');
            setNavigateToAdmin(false);
        }
    }, [navigateToAdmin, userData, setCurrentPage]);



    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;

if (!userData) return <div>Loading...</div>;


    return (
        <div style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100vw',
            boxSizing: 'border-box',
            position: 'relative',
        }}>
            <button
                onClick={handleAdminClick}
                style={{
                    backgroundImage: `url(${adminLogo})`,
                    backgroundSize: 'cover',
                    border: 'none',
                    width: '40px',
                    height: '40px',
                    cursor: 'pointer',
                    padding: 0,
                    position: 'absolute',
                    top: '10px',
                    left: '10px',
                }}
            />
            <div style={{
                maxWidth: isMobile ? '98vw' : '560px',
                width: isMobile ? '98vw' : undefined,
                border: '2px solid #4B5563',
                borderRadius: '8px',
                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                backgroundImage: `url(${cardBackgroundImage})`,
                backgroundSize: 'cover',
                padding: isMobile ? '10px' : '16px',
                margin: '20px auto 0',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <p style={{
                    color: '#4B5563',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                }}>
                    Email: {userData.email}
                </p>
                <p style={{
                    color: '#4B5563',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                }}>
                    Current Membership: {userData.membership_end_date && new Date(userData.membership_end_date) > new Date() ? userData.membership : userData.membership_type}
                </p>
                <p style={{
                    color: '#4B5563',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                }}>
                    Join Date: {userData.created_at ? new Date(userData.created_at).toLocaleDateString() : 'N/A'}
                </p>
                {(userData.membership_type === 'Monthly Subscription' || userData.membership_type === 'Yearly Subscription') && userData.membership_end_date ? (
                    <p style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                    }}>
                        Next Payment Due: {new Date(userData.membership_end_date).toLocaleDateString()}
                    </p>
                ) : (
                    userData.membership_end_date && (
                        <p style={{
                            color: '#4B5563',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            textAlign: 'center',
                        }}>
                            End Date: {new Date(userData.membership_end_date).toLocaleDateString()}
                        </p>
                    )
                )}
                {userData.next_membership_start && new Date(userData.next_membership_start) > new Date() && (
                    <p style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                    }}>
                        Next Membership: {userData.next_membership} starting {new Date(userData.next_membership_start).toLocaleDateString()}
                    </p>
                )}
            </div>
            <div style={{
                maxWidth: isMobile ? '98vw' : '560px',
                width: isMobile ? '98vw' : undefined,
                border: '2px solid #4B5563',
                borderRadius: '8px',
                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                backgroundImage: `url(${cardBackgroundImage})`,
                backgroundSize: 'cover',
                padding: isMobile ? '10px' : '16px',
                margin: '16px auto',
                boxSizing: 'border-box',
            }}>
                <p style={{
                    color: '#4B5563',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    marginBottom: '8px',
                }}>
                    {userData?.welcomeMessage[0]}
                </p>
                <p style={{
                    color: '#4B5563',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '18px',
                    fontWeight: 'bold',
                    marginBottom: '8px',
                }}>
                    {userData?.welcomeMessage[1]}
                </p>
                <p style={{
                    color: '#4B5563',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '18px',
                    fontWeight: 'bold',
                }}>
                    {userData?.welcomeMessage[2]}
                </p>
                {userData.welcomeMessage.length > 3 && (
                    <p style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                    }}>
                        {userData.welcomeMessage[3]}
                    </p>
                )}
            </div>
            <div style={{
                maxWidth: isMobile ? '98vw' : '560px',
                width: isMobile ? '98vw' : '560px',
                border: '2px solid #4B5563',
                borderRadius: '8px',
                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                backgroundImage: `url(${cardBackgroundImage})`,
                backgroundSize: 'cover',
                padding: isMobile ? '10px' : '16px',
                display: 'flex',
                flexDirection: 'column',
                minHeight: isMobile ? undefined : '400px',
                margin: '16px auto',
                boxSizing: 'border-box',
            }}>
                <div style={{
                    display: isMobile ? 'block' : 'flex',
                    alignItems: isMobile ? undefined : 'baseline',
                    gap: '8px',
                    marginBottom: '16px'
                }}>
                    <span style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                    }}>
                        Membership Options:
                    </span>
                    <span style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '15px',
                        fontWeight: 'normal',
                    }}>
                        click to view each
                    </span>
                </div>
                <div style={{ display: isMobile ? 'block' : 'flex', flex: 1 }}>
                    <div style={{
                        flex: 1.5,
                        paddingRight: isMobile ? 0 : '16px',
                        borderRight: isMobile ? 'none' : '1px solid #4B5563',
                        marginBottom: isMobile ? '12px' : 0,
                    }}>
                        {/* Screen reader instructions for radio group navigation */}
                        <span id="membership-instructions" style={{
                            position: 'absolute',
                            left: '-9999px',
                            width: '1px',
                            height: '1px',
                            overflow: 'hidden',
                        }}>
                            Use arrow keys to select a membership option.
                        </span>
                        {membershipOptions.map((option) => (
                            <div 
                                key={option.type} 
                                style={{ marginBottom: '8px', textAlign: 'left' }}
                                onMouseEnter={() => setHoveredMembership(option.type)}
                                onMouseLeave={() => setHoveredMembership(null)}
                            >
                                <label style={{
                                    fontFamily: 'Times New Roman, Times, serif',
                                    fontSize: '18px',
                                    fontWeight: 'bold',
                                    color: '#4B5563',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                }}>
                                    <input
                                        type="radio"
                                        name="membership"
                                        checked={selectedMembership === option.type}
                                        onChange={() => handleMembershipSelect(option.type)}
                                        aria-describedby="membership-instructions"
                                        style={{ margin: 0 }}
                                    />
                                    {option.type}
                                </label>
                            </div>
                        ))}
                        <div style={{ marginTop: '48px', paddingRight: '8px' }}>
                            <span style={{
                                fontFamily: 'Times New Roman, Times, serif',
                                fontSize: '14px',
                                color: '#4B5563',
                                display: 'block',
                                whiteSpace: 'pre-line',
                            }}>
                                {"\n\n\n"}Allow 48 hours in advance of next payment date to avoid further charges on your current subscription. Your full paid or gift membership will be honored before a switch to next membership will take place. Cancellation ends subscription immediately. No Refunds.
                            </span>
                        </div>
                    </div>
                    <div style={{
                        flex: '2',
                        paddingLeft: isMobile ? 0 : '16px',
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: isMobile ? undefined : '300px'
                    }}>
                        {(selectedMembership || hoveredMembership) && (
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                <div style={{ flex: 1, overflowY: 'auto' }}>
                                    <p style={{
                                        fontFamily: 'Times New Roman, Times, serif',
                                        fontSize: '16px',
                                        fontWeight: 'normal',
                                        color: '#4B5563',
                                        marginBottom: '16px',
                                        whiteSpace: 'pre-wrap',
                                    }}>
                                        {(selectedMembership || hoveredMembership) && membershipOptions.find(option => option.type === (selectedMembership || hoveredMembership)).description}
                                    </p>
                                    {selectedMembership === 'Gift' && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
                                            <span style={{
                                                fontFamily: 'Times New Roman, Times, serif',
                                                fontSize: '18px',
                                                fontWeight: 'bold',
                                                color: '#4B5563',
                                            }}>
                                                Gift
                                            </span>
                                            <input
                                                type="text"
                                                placeholder="Enter Coupon Code"
                                                value={couponCode}
                                                onChange={(e) => setCouponCode(e.target.value)}
                                                style={{
                                                    border: '2px solid black',
                                                    borderRadius: '10px',
                                                    padding: '5px',
                                                    width: '200px',
                                                    fontFamily: 'Times New Roman, Times, serif',
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                }}
                                            />
                                        </div>
                                    )}
                                    {(selectedMembership === 'Monthly' || selectedMembership === 'Yearly') && (
                                        <div style={{ marginBottom: '16px' }}>
                                            {/* Only show Stripe for Monthly and Yearly, hide PayPal tick box and PayPal subscribe button for both */}
                                            <label style={{
                                                fontFamily: 'Times New Roman, Times, serif',
                                                fontSize: '18px',
                                                fontWeight: 'bold',
                                                color: '#4B5563',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                            }}>
                                                <input
                                                    type="radio"
                                                    name="paymentMethod"
                                                    value="stripe"
                                                    checked={paymentMethod === 'stripe'}
                                                    onChange={() => setPaymentMethod('stripe')}
                                                    style={{ margin: 0 }}
                                                />
                                                Credit/Debit Card
                                            </label>
                                        </div>
                                    )}
                                </div>
                                {selectedMembership && (
                                    <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
                                        {selectedMembership === 'Gift' && (
                                            <button
                                                onClick={() => handleChangeMembership(selectedMembership, couponCode)}
                                                style={{
                                                    backgroundImage: `url(${buttonImage})`,
                                                    backgroundSize: 'cover',
                                                    border: '2px solid black',
                                                    borderRadius: '10px',
                                                    padding: '10px 30px',
                                                    width: 'auto',
                                                    fontFamily: 'Times New Roman, Times, serif',
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                                                }}
                                                disabled={!couponCode}
                                            >
                                                Change to Gift
                                            </button>
                                        )}
                                        {selectedMembership === 'Free' && (
                                            <button
                                                onClick={() => handleChangeMembership(selectedMembership)}
                                                style={{
                                                    backgroundImage: `url(${buttonImage})`,
                                                    backgroundSize: 'cover',
                                                    border: '2px solid black',
                                                    borderRadius: '10px',
                                                    padding: '10px 30px',
                                                    width: 'auto',
                                                    fontFamily: 'Times New Roman, Times, serif',
                                                    fontSize: '18px',
                                                    fontWeight: 'bold',
                                                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                                                }}
                                            >
                                                Change to Free
                                            </button>
                                        )}
                                        {/* PayPal subscribe button for Monthly and Yearly removed (now handled by Stripe or other logic) */}
                                        {(selectedMembership === 'Monthly' || selectedMembership === 'Yearly') && paymentMethod === 'stripe' && (
                                            <button
                                                onClick={handleStripeCheckout}
                                                style={{
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    padding: 0,
                                                    background: 'none',
                                                    boxShadow: 'none',
                                                    marginTop: '-80px', // move up by 80px
                                                    marginBottom: '50px', // add 50px buffer below the image
                                                    cursor: 'pointer',
                                                    display: 'inline-block',
                                                }}
                                            >
                                                <img
                                                    src="/images/paywithstripe.webp"
                                                    alt="Pay with Stripe"
                                                    style={{
                                                        height: '80px',
                                                        width: 'auto',
                                                        display: 'block',
                                                    }}
                                                    onError={e => {
                                                        e.target.style.display = 'none';
                                                        e.target.parentNode.textContent = 'Pay with Card';
                                                    }}
                                                />
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {paymentConfirmed && subscriptionId && (userData.membership_type === 'Monthly Subscription' || userData.membership_type === 'Yearly Subscription') && (
                <div style={{
                    maxWidth: isMobile ? '98vw' : '560px',
                    width: isMobile ? '98vw' : undefined,
                    border: '2px solid #4B5563',
                    borderRadius: '8px',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    padding: isMobile ? '10px' : '16px',
                    margin: '16px auto',
                    boxSizing: 'border-box',
                }}>
                    <p style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        marginBottom: '16px',
                    }}>
                        Your first Payment is Confirmed. Thank you!
                    </p>
                    <p style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                    }}>
                        Subscription ID: {subscriptionId}
                    </p>
                    <p style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        marginTop: '16px',
                    }}>
                        {userData.membership_type === 'Monthly Subscription' ? (
                            'You are Subscribed with a Monthly Membership. Your next payment will be automatically charged 30 days from your start date. You may change your membership type at any time, but there are No Refunds. Your subscription will finish before the change takes place.'
                        ) : (
                            'You are Subscribed with a Yearly Membership. Your next payment will be automatically charged 365 days from your start date. You may change your membership type at any time, but there are No Refunds. Your subscription will finish before the change takes place.'
                        )}
                    </p>
                </div>
            )}
            <div style={{
                display: isMobile ? 'flex' : 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? '10px' : '16px',
                flexWrap: isMobile ? 'nowrap' : 'wrap',
                justifyContent: 'center',
                alignItems: isMobile ? 'stretch' : 'flex-start',
                width: isMobile ? '98vw' : undefined,
                margin: isMobile ? '0 auto' : undefined,
                boxSizing: 'border-box',
            }}>
                <div style={{
                    maxWidth: isMobile ? '98vw' : '560px',
                    minWidth: isMobile ? '0' : '340px',
                    flex: '1 1 340px',
                    border: '2px solid #4B5563',
                    borderRadius: '8px',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    padding: isMobile ? '10px' : '16px',
                    margin: isMobile ? '0 auto' : undefined,
                    boxSizing: 'border-box',
                }}>
                    <p style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        marginBottom: '8px',
                    }}>
                        Change Password:
                    </p>
                    <input
                        type="password"
                        placeholder="Current Password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        style={{
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '5px',
                            width: '340px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            marginBottom: '8px',
                        }}
                    />
                    <input
                        type="password"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        style={{
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '5px',
                            width: '340px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            marginBottom: '8px',
                        }}
                    />
                    <input
                        type="password"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        style={{
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '5px',
                            width: '340px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            marginBottom: '8px',
                        }}
                    />
                    <button
                        onClick={handlePasswordChange}
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 30px',
                            width: 'auto',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                    >
                        Submit
                    </button>
                    <p
                        onClick={handleForgotPassword}
                        style={{
                            color: '#4B5563',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            marginTop: '8px',
                        }}
                    >
                        Forgot Password?
                    </p>
                </div>
                <div style={{
                    maxWidth: isMobile ? '98vw' : '560px',
                    minWidth: isMobile ? '0' : '340px',
                    border: '2px solid #4B5563',
                    borderRadius: '8px',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    padding: isMobile ? '10px' : '16px',
                    margin: isMobile ? '0 auto' : undefined,
                    boxSizing: 'border-box',
                }}>
                    <p style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                    }}>
                        Change Nickname (Limit 1 change):
                    </p>
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: '#4B5563',
                        textAlign: 'center',
                        marginBottom: '8px',
                        whiteSpace: 'pre-line',
                    }}>
                        Your nickname will also be used
                        {'\n'}to identify you in the chat room.
                        {'\n'}Your first name will be used
                        {'\n'}if no nickname is provided.
                    </p>
                    <input
                        type="text"
                        value={nickname}
                        onChange={(e) => setNickname(e.target.value)}
                        style={{
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '5px',
                            width: '90%',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            marginBottom: '8px',
                        }}
                        disabled={nicknameChanged}
                    />
                    <button
                        onClick={handleNicknameChange}
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 30px',
                            width: 'auto',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        disabled={nicknameChanged}
                    >
                        Submit
                    </button>
                </div>
            </div>
            <div style={{
                maxWidth: isMobile ? '98vw' : '560px',
                width: isMobile ? '98vw' : '560px',
                border: '2px solid #4B5563',
                borderRadius: '8px',
                boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                backgroundImage: `url(${cardBackgroundImage})`,
                backgroundSize: 'cover',
                padding: isMobile ? '10px' : '16px',
                margin: '16px auto',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}>
                <h3 style={{
                    color: '#4B5563',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    marginBottom: '12px',
                }}>
                    Terms Of Service
                </h3>
                <p style={{
                    color: 'black',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                    marginBottom: '12px',
                    lineHeight: '1.5',
                }}>
                    Hi, I'm Julie. I developed this app with the help of Copilot and Grok. When I started I did not know anything about coding or creating an app. It has been a long process with a lot of trial and error and here we are with 7 months put into the development and I am about ready to launch the app.
                </p>
                <p style={{
                    color: 'black',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                    marginBottom: '12px',
                    lineHeight: '1.5',
                }}>
                    The most important reason you should know about how this app was developed is so that you understand that we may have some upgrades that need to happen as the app gets used more. There are no refunds for your monthly or yearly subscription, but I welcome you to report to me if there is any issue. I will work on fixing them as soon as possible. Even if no issues are found there will potentially be periodic upgrades to the app and when that happens there may be a need to update your app if you have it downloaded. You will be informed of any such case. Any down time will be as short as possible. This app may not appear well on some tablets and browsers. That is what you need to know about regarding the technical side. 
                </p>
                <p style={{
                    color: 'black',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                    marginBottom: '12px',
                    lineHeight: '1.5',
                }}>
                    The purpose of this app is to organize and offer the wisdom I have gained in self reflection to others who may want to have some reassurance, comfort, insight, wisdom, and knowledge, to reflect on during their own process. I designed this by including information on topics and tools that helped me along the way as well addressing patterns that I found after giving readings to the general public for more than a year. I have also set up a way for users to use my question and answer flow type interactive components to give step by step support through their process should they decide this method is right for them. The formulas I have shared for moving the energy and releasing patterns are those that I used and developed during my own process. Others have also found success with these formulas. I want the app to feel like a bit of a companion to your journey. It is still up to you to decide if something is good for you or not, and to take responsibility for how you use this tool and the results you get or do not get. 
                </p>
                <p style={{
                    color: 'black',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                    marginBottom: '12px',
                    lineHeight: '1.5',
                }}>
                    This app requires users to be willing to take responsibility for discerning what offerings are appropriate and helpful to them and which are not. The user must take full responsibility for using this app and the information and formulas included. The user's thoughts, feelings, and behaviors are their own. This information is not offered by a professional or doctor. This is simply the information that I learned and that has worked for me. I found it very effective and useful to have this information and I want to make sure others know about the process I used with reflection to resolve difficult fears, limitations, and repeating patterns. By choosing to subscribe you agree to the terms of using this app. You agree to taking full responsibilty for yourself, your wellness, your discernment about what methods and modalities are good for your own wellness. Delete Account if you do not agree.
                </p>
                <p style={{
                    color: 'black',
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    textAlign: 'left',
                    marginBottom: '0',
                    lineHeight: '1.5',
                }}>
                    Thank you so much for being here and participating in the app. I am so excited to offer it and to be developing it on a continual basis. There will be live sessions and Q&A updates ongoing. I am looking forward to it!
                </p>
                <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        marginTop: '18px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: '#007AFF',
                        textDecoration: 'underline',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        display: 'block',
                    }}
                >
                    Privacy Policy
                </a>
            </div>
            <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? '10px' : '16px',
                justifyContent: 'center',
                alignItems: 'stretch',
                width: isMobile ? '98vw' : '560px',
                margin: '16px auto',
                boxSizing: 'border-box',
            }}>
                <div style={{
                    flex: 1,
                    maxWidth: isMobile ? '98vw' : '270px',
                    minWidth: isMobile ? '0' : '270px',
                    border: '2px solid #4B5563',
                    borderRadius: '8px',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    padding: isMobile ? '10px' : '16px',
                    margin: isMobile ? '0 auto' : undefined,
                    boxSizing: 'border-box',
                }}>
                    <p style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        marginBottom: '8px',
                    }}>
                        Feedback / Report
                    </p>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 30px',
                            width: 'auto',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={() => window.open('mailto:Startellina@gmail.com', '_blank')}
                    >
                        Feedback/Report
                    </button>
                </div>
                <div style={{
                    flex: 1,
                    maxWidth: isMobile ? '98vw' : '270px',
                    minWidth: isMobile ? '0' : '270px',
                    border: '2px solid #4B5563',
                    borderRadius: '8px',
                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    padding: isMobile ? '10px' : '16px',
                    margin: isMobile ? '0 auto' : undefined,
                    boxSizing: 'border-box',
                }}>
                    <p style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '18px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                    }}>
                        Cancel:
                    </p>
                    <button
                        onClick={async () => {
                            // Check for subscription before attempting cancellation
                            if (!userData || !userData.subscription_id) {
                                alert('No paid subscription found.');
                                return;
                            }
                            try {
                                const { data: { session } } = await supabase.auth.getSession();
                                const token = session?.access_token;
                                const res = await fetch('/functions/v1/cancel-subscription', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Authorization': `Bearer ${token}`,
                                    },
                                    body: JSON.stringify({ user_id: userData.id }),
                                });
                                if (res.ok) {
                                    alert('Your subscription has been cancelled. You will no longer be charged for your subscription.  You can activate your subscription again at any time on the My Account page. Email support at [startellina@gmail.com] with any questions.');
                                    await fetchUserData();
                                } else {
                                    alert('No Active Subscription found. Please contact Support with any questions. Startellina@gmail.com');
                                }
                            } catch (err) {
                                alert('No Active Subscription found. Please contact Support with any questions. Startellina@gmail.com');
                            }
                        }}
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 30px',
                            width: 'auto',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                    >
                        Cancel Subscription
                    </button>
                    <button
                        onClick={handleDeleteAccount}
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 30px',
                            width: 'auto',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                            marginBottom: '18px',
                        }}
                    >
                        **Delete Account**
                    </button>
                </div>
            </div>
            <div style={{
                display: isMobile ? 'flex' : 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                gap: isMobile ? '8px' : '16px',
                flexWrap: isMobile ? 'nowrap' : 'wrap',
                justifyContent: 'center',
                alignItems: isMobile ? 'stretch' : 'center',
                marginTop: isMobile ? '18px' : '56px',
                width: isMobile ? '98vw' : undefined,
                padding: isMobile ? '0 2vw' : undefined,
                boxSizing: 'border-box',
            }}>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: isMobile ? '10px 0' : '10px 30px',
                        width: isMobile ? '100%' : 'auto',
                        minWidth: isMobile ? '0' : undefined,
                        fontFamily: 'Times New Roman, Times, serif',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        fontSize: isMobile ? '16px' : undefined,
                        margin: 5,
                    }}
                    onClick={goBack}
                >
                    Back
                </button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: isMobile ? '10px 0' : '10px 30px',
                        width: isMobile ? '100%' : 'auto',
                        minWidth: isMobile ? '0' : undefined,
                        fontFamily: 'Times New Roman, Times, serif',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        fontSize: isMobile ? '16px' : undefined,
                        margin: 0,
                    }}
                    onClick={() => setCurrentPage('home')}
                >
                    Home
                </button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: isMobile ? '10px 0' : '10px 30px',
                        width: isMobile ? '100%' : 'auto',
                        minWidth: isMobile ? '0' : undefined,
                        fontFamily: 'Times New Roman, Times, serif',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        fontSize: isMobile ? '16px' : undefined,
                        margin: 0,
                    }}
                    onClick={handleLogout}
                >
                    Logout
                </button>
            </div>
            {showDeleteConfirm && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'white',
                    padding: isMobile ? '10px' : '20px',
                    border: '2px solid #4B5563',
                    borderRadius: '8px',
                    boxShadow: '0 0 10px rgba(0,0,0,0.5)',
                    zIndex: 1000,
                    width: isMobile ? '90vw' : undefined,
                    minWidth: isMobile ? '0' : undefined,
                    maxWidth: isMobile ? '95vw' : undefined,
                }}>
                    <p style={{
                        color: '#4B5563',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: isMobile ? '16px' : '18px',
                        fontWeight: 'bold',
                        textAlign: 'center',
                    }}>
                        If you are sure you want to delete your account click delete account. Any Active Subscriptions will be Cancelled. You will lose access immediately with No Refund. You may regain access to the app by starting a new subscription at any time. Email support to request deletion from the records completely. startellina@gmail.com
                    </p>
                    <div style={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: isMobile ? '8px' : '16px',
                        marginTop: isMobile ? '10px' : '20px',
                    }}>
                        <button
                            onClick={() => confirmDeleteAccount(true)}
                            style={{
                                backgroundImage: `url(${buttonImage})`,
                                backgroundSize: 'cover',
                                border: '2px solid black',
                                borderRadius: '10px',
                                padding: isMobile ? '10px 0' : '10px 30px',
                                width: isMobile ? '100%' : 'auto',
                                minWidth: isMobile ? '0' : undefined,
                                fontFamily: 'Times New Roman, Times, serif',
                                fontSize: isMobile ? '16px' : '18px',
                                fontWeight: 'bold',
                                boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                                margin: 0,
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                            }}
                        >
                                                       Delete Account
                        </button>
                        <button
                            onClick={() => confirmDeleteAccount(false)}
                            style={{
                               

                               
                                backgroundImage: `url(${buttonImage})`,
                                backgroundSize: 'cover',
                                border: '2px solid black',
                                borderRadius: '10px',
                                padding: isMobile ? '10px 0' : '10px 30px',
                                width: isMobile ? '100%' : 'auto',
                                minWidth: isMobile ? '0' : undefined,
                                fontFamily: 'Times New Roman, Times, serif',
                                fontSize: isMobile ? '16px' : '18px',
                                fontWeight: 'bold',
                                boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                                margin: 0,
                                whiteSpace: 'normal',
                                wordBreak: 'break-word',
                            }}
                        >
                            Keep Account
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MyAccount;